module.exports = __webpack_public_path__ + "img/asus-x543.13bab29d.jpg";